/* 
    Función que comprueba si un valor está rellenado.

    Entrada:
        - value

    Salida:
        - boolean
*/
const isFilled = (value) => {
    if(value == undefined || value == null || value == '' || value == {} || value == []){
        return false;
    }
    else if(typeof value === 'object' && !Array.isArray(value) && value !== null){
        if(Object.keys(value).length === 0 && Object.getPrototypeOf(value) === Object.prototype){
            return false;
        }
    }

    return true;
}

export default isFilled